<template lang="pug">
  filters-common(
    v-if='loaded',
    :data='filters'
  )
</template>

<script>
import FiltersCommon from '../filter/FiltersCommon'
import GraficoIdEnum from '../../../enum/graficoId'

export default {
  name: 'DigitalWalletBalance',

  components: {
    FiltersCommon
  },

  data () {
    return {
      loaded: false,
      gadget: this.$store.getters.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.SALDO_CARTEIRA_DIGITAL),
      filters: [
        {
          name: 'agrupamentoCategoria',
          options: [],
          onChange: this.setSelected('setCategorySelectedDigitalWalletBalance', 'agrupamentoCategoria'),
          order: 1,
          convertIdTo: id => Number(id)
        }
      ]
    }
  },

  computed: {
    periodoDashboard () {
      return this.$store.getters.periodFilterDigitalWalletBalance
    }
  },

  watch: {
    periodoDashboard: {
      handler () {
        this.setFilter('periodoResultado', this.periodoDashboard)
      },
      deep: true
    }
  },

  methods: {
    setSelectFlags () {
      for (const filter of this.filters) {
        const param = this.getParam(filter.name)
        for (const option of filter.options) {
          option.__selected = param && param.valor === option.id
        }
      }
      this.loaded = true
    },

    getParam (filterName) {
      return this.gadget.gadgetParam.find(param => param.nome === filterName)
    },

    setFilter (filterName, value) {
      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return
      }

      const param = this.getParam(filterName)
      if (!param) {
        return
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id
        this.$store.dispatch('loadingData')
        this.$store.dispatch('cancelDashboardRequests')
        this.$store.dispatch('setGadgetConfig', this.gadget)
          .finally(() => {
            this.$store.dispatch('dataLoaded')
          })
      }
    },

    setSelected (eventName, filterName) {
      return result => {
        if (result && result.id) {
          this.$store.dispatch(eventName, result)
          this.setFilter(filterName, result.id)
        }
      }
    },

    async getCategories () {
      const response = await this.$store.dispatch('getCategories', {
        url: '/dashboard/loadCategories',
        flTipoCategoria: 'W',
        validarUso: false
      })
      const categories = response.data

      return [
        {
          id: 'TD',
          label: this.$t('dashboard.filtro.tipo.T')
        },
        ...categories
          .map(category => {
            return {
              id: category.id,
              label: `${category.numero} - ${category.nome}`,
              numero: category.numero,
              nome: category.nome
            }
          }).sort((a, b) => {
            if (a.numero > b.numero) {
              return 1
            }
            if (a.numero < b.numero) {
              return -1
            }

            return a.nome.localeCompare(b.nome)
          })
      ]
    }
  },

  created () {
    const self = this
    this.getCategories()
      .then(categories => {
        const categoryFilter = self.filters.find(filter => filter.name === 'agrupamentoCategoria')
        categoryFilter.options = categories
        self.setSelectFlags()
      })
  }
}
</script>



// WEBPACK FOOTER //
// DigitalWalletBalance.vue?1261b56c